import { Environment, WidgetEnvironment } from '@s/platform/Environment';
import React from 'react';

export const environment = new WidgetEnvironment(['PC', 'iOS', 'Android']);
export const ConsoleEnvContext = React.createContext<Environment>(environment);
